import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App.js";
import { Root } from "./Root";
//Root is the root component for the redux store, to help with testing we can wrap any component in this root
import reportWebVitals from "./helpers/reportWebVitals.js";
import { setUpDev } from "helpers/dev";

setUpDev();

ReactDOM.render(
  <React.StrictMode>
    <Root>
      <App />
    </Root>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(window.efs_debug && window.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
